<template>
    <v-container>
        <div v-html="htmlQR"></div>
    </v-container>
</template>

<script>
export default {
    name: 'MerchantViewQR',
    props: {},
    data() {
        return {
            htmlQR: ''
        };
    },
    methods: {
        initiate() {
            this.getData();
        },
        getData() {
            this.$store
                .dispatch('merchants/findMerchantQR', {
                    id: this.$route.params.id
                })
                .then((response) => {
                    this.htmlQR = response;

                    setTimeout(() => {
                        window.print();
                    }, 500);
                });
        }
    },
    created() {
        this.initiate();
    }
};
</script>

<style lang="scss" scoped></style>
